var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4C9.14937 4 4 9.14937 4 15.5C4 21.8506 9.14937 27 15.5 27C21.8506 27 27 21.8506 27 15.5C27 9.14937 21.8506 4 15.5 4Z",
    stroke: "#747067",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.75H15.75V21",
    stroke: "#747067",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.25H18.5",
    stroke: "#747067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.125C15.1786 8.125 14.8644 8.2203 14.5972 8.39886C14.33 8.57742 14.1217 8.83121 13.9987 9.12814C13.8757 9.42507 13.8435 9.7518 13.9062 10.067C13.9689 10.3822 14.1237 10.6718 14.351 10.899C14.5782 11.1263 14.8678 11.2811 15.183 11.3438C15.4982 11.4065 15.8249 11.3743 16.1219 11.2513C16.4188 11.1283 16.6726 10.92 16.8511 10.6528C17.0297 10.3856 17.125 10.0714 17.125 9.75C17.125 9.31902 16.9538 8.9057 16.649 8.60095C16.3443 8.2962 15.931 8.125 15.5 8.125V8.125Z",
    fill: "#747067"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b6586268.svg";
export { ForwardRef as ReactComponent };